unit uDriverChoice;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.REST, Data.DB, WEBLib.CDS, WEBLib.DB,
  WEBLib.Grids, Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.Storage,
  WEBLib.JSON, WEBLib.JsonData, uHTTPHelper, WEBLib.ExtCtrls, WEBLib.Buttons,
  Vcl.StdCtrls, WEBLib.StdCtrls, uGlobal;

type
  TfrmDriverChoice = class(TForm)
    datasource: TDataSource;
    con: TClientConnection;
    dataset: TClientDataSet;
    gdDrivers: TDBGrid;
    datasetid: TIntegerField;
    datasetdriverid: TStringField;
    datasetcode: TStringField;
    dataseturl: TStringField;
    datasetgivenname: TStringField;
    datasetfamilyname: TStringField;
    datasetfullname: TStringField;
    datasetnationality: TStringField;
    pnTop: TPanel;
    btClose: TSpeedButton;
    WebLabel1: TLabel;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure gdDriversClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure conConnectError(Sender: TObject; ErrorCode: Integer);
    procedure btCloseClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    ChoosenID : integer;
    ChoosenName : string;
    [async]
    procedure SendTestRequest; async;
  protected procedure LoadDFMValues; override; end;

var
  frmDriverChoice: TfrmDriverChoice;

implementation

{$R *.dfm}

procedure TfrmDriverChoice.btCloseClick(Sender: TObject);
begin
  ChoosenID := -1;
  ChoosenName := '';
  Close;
end;

procedure TfrmDriverChoice.conConnectError(Sender: TObject; ErrorCode: Integer);
begin
  ShowMessage('Fehler beim Verbinden zu Driver-Ressource, Code: ' + ErrorCode.ToString);
  ChoosenID := -1;
  ChoosenName := '';
  Close;
end;


procedure TfrmDriverChoice.gdDriversClickCell(Sender: TObject; ACol,
  ARow: Integer);
begin
  ChoosenID := dataset.FieldByName('id').AsInteger;
  ChoosenName := dataset.FieldByName('fullname').AsString;
  Close;
end;

procedure TfrmDriverChoice.SendTestRequest;
var
  jo: TJSONObject;
  status: integer;
  ls : TLocalStorage;
begin
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/testauth/', httpGET, '', jo));
  jo.free;
  if (Status <> HTTP_OK) then
  begin
    ShowMessage('AuthCall fehlgeschlagen: ' + status.ToString);
    exit;
  end;

  ChoosenID := -1;
  ChoosenName := '';
  ls := TLocalStorage.Create(nil);
  try
    con.Headers.Clear;
    con.Headers.Values['Authorization'] := 'Bearer ' + ls.GetValue('accesstoken');
    con.open;
  finally
    ls.free;
  end;


end;

procedure TfrmDriverChoice.WebFormCreate(Sender: TObject);
var
  ls : TLocalStorage;

begin
  gdDrivers.Columns[0].Width := Width;

  //Vorab Request herausschicken, welcher prüft ob Authorization gegeben ist
  //Falls nicht wird neuer AccessToken angefordert
  con.URI := F1BET_SERVER + '/drivers/';

  SendTestRequest; //Öffnet jetzt auch die con

  {ChoosenID := -1;
  ChoosenName := '';
  ls := TLocalStorage.Create(nil);
  try
    con.Headers.Clear;
    con.Headers.Values['Authorization'] := 'Bearer ' + ls.GetValue('accesstoken');
    con.open;
  finally
    ls.free;
  end;                                        }
end;

procedure TfrmDriverChoice.WebFormDestroy(Sender: TObject);
begin
  con.close;
end;

procedure TfrmDriverChoice.WebFormResize(Sender: TObject);
begin
  //Spaltenbreite immer auf Fensterbreite anpassen
  console.log('Resize: ' + gdDrivers.Columns[0].Width.ToString + ' / ' + Width.ToString);
  gdDrivers.Columns[0].Width := Width;
end;

procedure TfrmDriverChoice.LoadDFMValues;
begin
  inherited LoadDFMValues;

  gdDrivers := TDBGrid.Create(Self);
  pnTop := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  btClose := TSpeedButton.Create(Self);
  datasource := TDataSource.Create(Self);
  con := TClientConnection.Create(Self);
  dataset := TClientDataSet.Create(Self);
  datasetid := TIntegerField.Create(Self);
  datasetdriverid := TStringField.Create(Self);
  datasetcode := TStringField.Create(Self);
  dataseturl := TStringField.Create(Self);
  datasetgivenname := TStringField.Create(Self);
  datasetfamilyname := TStringField.Create(Self);
  datasetfullname := TStringField.Create(Self);
  datasetnationality := TStringField.Create(Self);

  gdDrivers.BeforeLoadDFMValues;
  pnTop.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  btClose.BeforeLoadDFMValues;
  datasource.BeforeLoadDFMValues;
  con.BeforeLoadDFMValues;
  dataset.BeforeLoadDFMValues;
  datasetid.BeforeLoadDFMValues;
  datasetdriverid.BeforeLoadDFMValues;
  datasetcode.BeforeLoadDFMValues;
  dataseturl.BeforeLoadDFMValues;
  datasetgivenname.BeforeLoadDFMValues;
  datasetfamilyname.BeforeLoadDFMValues;
  datasetfullname.BeforeLoadDFMValues;
  datasetnationality.BeforeLoadDFMValues;
  try
    Name := 'frmDriverChoice';
    Width := 288;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    gdDrivers.SetParentComponent(Self);
    gdDrivers.Name := 'gdDrivers';
    gdDrivers.Left := 0;
    gdDrivers.Top := 50;
    gdDrivers.Width := 288;
    gdDrivers.Height := 424;
    gdDrivers.Anchors := [akLeft,akTop,akRight,akBottom];
    gdDrivers.Columns.Clear;
    with gdDrivers.Columns.Add do
    begin
      DataField := 'fullname';
      Width := 300;
    end;
    gdDrivers.DefaultRowHeight := 45;
    gdDrivers.DataSource := datasource;
    gdDrivers.FixedFont.Charset := DEFAULT_CHARSET;
    gdDrivers.FixedFont.Color := clWindowText;
    gdDrivers.FixedFont.Height := -12;
    gdDrivers.FixedFont.Name := 'Segoe UI';
    gdDrivers.FixedFont.Style := [];
    gdDrivers.FixedCols := 0;
    gdDrivers.FixedRows := 0;
    gdDrivers.Font.Charset := DEFAULT_CHARSET;
    gdDrivers.Font.Color := clWindowText;
    gdDrivers.Font.Height := -19;
    gdDrivers.Font.Name := 'Tahoma, Arial, sans-serif';
    gdDrivers.Font.Style := [];
    gdDrivers.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRowSelect,goFixedRowDefAlign];
    gdDrivers.ParentFont := False;
    gdDrivers.TabOrder := 0;
    gdDrivers.HeightPercent := 100.000000000000000000;
    gdDrivers.StyleElements := [seClient,seBorder];
    gdDrivers.WidthPercent := 100.000000000000000000;
    SetEvent(gdDrivers, Self, 'OnClickCell', 'gdDriversClickCell');
    gdDrivers.ColWidths[0] := 300;
    pnTop.SetParentComponent(Self);
    pnTop.Name := 'pnTop';
    pnTop.Left := 0;
    pnTop.Top := 0;
    pnTop.Width := 288;
    pnTop.Height := 51;
    pnTop.Align := alTop;
    pnTop.ChildOrder := 4;
    pnTop.Color := 15890688;
    pnTop.TabOrder := 1;
    WebLabel1.SetParentComponent(pnTop);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 12;
    WebLabel1.Top := 17;
    WebLabel1.Width := 147;
    WebLabel1.Height := 19;
    WebLabel1.Caption := 'W'#228'hle einen Fahrer';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWhite;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Arial';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    btClose.SetParentComponent(Self);
    btClose.Name := 'btClose';
    btClose.Left := 237;
    btClose.Top := 3;
    btClose.Width := 48;
    btClose.Height := 48;
    btClose.Anchors := [akTop,akRight];
    btClose.Color := 15890688;
    btClose.ElementClassName := 'btn';
    btClose.HeightPercent := 100.000000000000000000;
    btClose.MaterialGlyph := 'close';
    btClose.MaterialGlyphColor := clWhite;
    btClose.MaterialGlyphSize := 32;
    btClose.TabOrder := 2;
    btClose.WidthPercent := 100.000000000000000000;
    SetEvent(btClose, Self, 'OnClick', 'btCloseClick');
    datasource.SetParentComponent(Self);
    datasource.Name := 'datasource';
    datasource.DataSet := dataset;
    datasource.Left := 60;
    datasource.Top := 420;
    con.SetParentComponent(Self);
    con.Name := 'con';
    con.Active := False;
    con.Delimiter := ';';
    con.URI := 'http://localhost:1999/drivers/';
    SetEvent(con, Self, 'OnConnectError', 'conConnectError');
    con.Left := 56;
    con.Top := 356;
    dataset.SetParentComponent(Self);
    dataset.Name := 'dataset';
    dataset.Connection := con;
    dataset.Left := 64;
    dataset.Top := 284;
    datasetid.SetParentComponent(dataset);
    datasetid.Name := 'datasetid';
    datasetid.FieldName := 'id';
    datasetdriverid.SetParentComponent(dataset);
    datasetdriverid.Name := 'datasetdriverid';
    datasetdriverid.FieldName := 'driverid';
    datasetdriverid.Size := 256;
    datasetcode.SetParentComponent(dataset);
    datasetcode.Name := 'datasetcode';
    datasetcode.FieldName := 'code';
    datasetcode.Size := 256;
    dataseturl.SetParentComponent(dataset);
    dataseturl.Name := 'dataseturl';
    dataseturl.FieldName := 'url';
    dataseturl.Size := 256;
    datasetgivenname.SetParentComponent(dataset);
    datasetgivenname.Name := 'datasetgivenname';
    datasetgivenname.FieldName := 'givenname';
    datasetgivenname.Size := 256;
    datasetfamilyname.SetParentComponent(dataset);
    datasetfamilyname.Name := 'datasetfamilyname';
    datasetfamilyname.FieldName := 'familyname';
    datasetfamilyname.Size := 256;
    datasetfullname.SetParentComponent(dataset);
    datasetfullname.Name := 'datasetfullname';
    datasetfullname.FieldName := 'fullname';
    datasetfullname.Size := 256;
    datasetnationality.SetParentComponent(dataset);
    datasetnationality.Name := 'datasetnationality';
    datasetnationality.FieldName := 'nationality';
    datasetnationality.Size := 256;
  finally
    gdDrivers.AfterLoadDFMValues;
    pnTop.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    btClose.AfterLoadDFMValues;
    datasource.AfterLoadDFMValues;
    con.AfterLoadDFMValues;
    dataset.AfterLoadDFMValues;
    datasetid.AfterLoadDFMValues;
    datasetdriverid.AfterLoadDFMValues;
    datasetcode.AfterLoadDFMValues;
    dataseturl.AfterLoadDFMValues;
    datasetgivenname.AfterLoadDFMValues;
    datasetfamilyname.AfterLoadDFMValues;
    datasetfullname.AfterLoadDFMValues;
    datasetnationality.AfterLoadDFMValues;
  end;
end;

end.